import React, { useEffect, useState } from "react";

// Motivational quotes array
const quotes = [
    "Join us to transform solar energy into a seamless experience",
    "Empowering sustainable energy solutions, one project at a time",
    "Your journey to clean energy starts here with us",
    "Together, we make solar simple and accessible for everyone",
    "Building a brighter, greener future through innovation"
];


const backgroundImages = [
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1200&q=80",
    "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=1200&q=80",
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1200&q=80",
    "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=1200&q=80",
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1200&q=80"
];

const LoginQuotesPanel = () => {
    const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);

    // Auto-slide quotes every 4 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="login-right login-right-with-bg">
            {/* Background Image with Opacity */}
            <div
                className="login-right-background"
                style={{
                    backgroundImage: `url(${backgroundImages[currentQuoteIndex]})`
                }}
            />

            {/* Content */}
            <div className="login-right-content">
                {/* Sliding Quote Section */}
                <div className="quote-slider-container">
                    <h2 key={currentQuoteIndex} className="quote-text">
                        {quotes[currentQuoteIndex]}
                    </h2>

                    {/* Quote indicators */}
                    <div className="quote-indicators">
                        {quotes.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentQuoteIndex(index)}
                                className={`quote-dot ${currentQuoteIndex === index ? 'active' : ''}`}
                                aria-label={`Go to quote ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginQuotesPanel;
